import { useState, type FormEvent } from 'react';

interface SubmitState {
  status: 'idle' | 'submitting' | 'success' | 'error';
  message: string;
}

interface ParsedResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

export default function useReaddyForm(submitAddr: string, honeypotName: string) {
  const [state, setState] = useState<SubmitState>({ status: 'idle', message: '' });

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get(honeypotName) || '').trim();
    if (honeypot) {
      setState({ status: 'success', message: '提交成功，我们会尽快与你联系。' });
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === honeypotName) return;
      const text = String(value);
      if (!text) return;
      payload.append(key, text);
    });

    setState({ status: 'submitting', message: '' });

    try {
      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();

      let parsed: ParsedResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as ParsedResponse;
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam =
        typeof serverMsg === 'string' &&
        (serverMsg.includes('spam') || serverMsg.includes('form data is spam'));

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setState({ status: 'success', message: '提交成功，感谢你的参与，我们会尽快回复。' });
        form.reset();
      } else {
        const fallback = '提交失败，请检查内容后重试。';
        setState({
          status: 'error',
          message: typeof serverMsg === 'string' && serverMsg.trim() ? serverMsg : fallback,
        });
      }
    } catch {
      setState({ status: 'error', message: '网络异常，请稍后重试。' });
    }
  };

  return { state, handleSubmit };
}